import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
];

const LanguageSelector = () => {
  const { user, updateLanguage } = useAuth();

  const handleLanguageChange = async (language) => {
    try {
      await updateLanguage(language);
      toast.success('Language updated successfully');
    } catch (error) {
      toast.error('Failed to update language');
    }
  };

  return (
    <div className="flex items-center gap-1 sm:gap-2">
      <Globe className="w-4 h-4 text-slate-600 hidden sm:block" />
      <Select value={user?.language || 'en'} onValueChange={handleLanguageChange}>
        <SelectTrigger className="w-[90px] sm:w-[140px] text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span className="hidden sm:inline">{lang.name}</span>
                <span className="sm:hidden">{lang.code.toUpperCase()}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector;